// Copyright (c) 2016 Deere & Company

import ClaimDetailsContainer from './claim-details-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    claim: state.claims.attachment.claim,
    formValidation: state.claims.attachment.formValidation,
    isEditable: state.claims.attachment.isEditable,
    isValidClaim: state.claims.attachment.isValidClaim,
    ownershipStatus: state.claims.ownershipStatus,
    rgaStatus: state.claims.attachment.claim.rgaStatus,
    selectedAccounts: state.user.details.settings.dealer.accounts.selectedAccounts
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ClaimDetailsContainer);



// WEBPACK FOOTER //
// ./src/claim/attachment/components/claim-details-section/index.js